import axios from "axios";
const apiAdder = process.env.VUE_APP_API;
export async function getList() {
  const token = localStorage.getItem("token");
  return axios
    .get(`${apiAdder}business-account/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function getAccount(_, id) {
  const token = localStorage.getItem("token");
  return axios
    .get(`${apiAdder}business-account/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function deleteAccount(_, id) {
  const token = localStorage.getItem("token");
  return axios
    .delete(`${apiAdder}/business-account/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function addAccount(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}business-account/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function updateAccount(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .patch(`${apiAdder}business-account/${data.id}`, data.acc, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}

export async function getAccountCategoryList() {
  const token = localStorage.getItem("token");
  return axios
    .get(`${apiAdder}business-category/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
